/**
 * Script d'ajout automatique au panier pour les abonnements dans la section media-split
 * Version: 1.0
 */

console.log('✅ Script media-split-subscription.js chargé');

document.addEventListener('click', function(e) {
  // Trouver si le clic vient d'un lien avec la classe media-split-add-subscription
  const link = e.target.closest('a.media-split-add-subscription');
  
  if (!link) return;
  
  // Récupérer les données d'abonnement
  const sellingPlanId = link.getAttribute('data-subscription-selling-plan');
  const productUrl = link.getAttribute('data-product-url');
  
  if (!sellingPlanId || !productUrl) {
    console.warn('⚠️ Données d\'abonnement manquantes');
    return;
  }
  
  // 🔥 BLOCAGE TOTAL de la redirection
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  
  console.log('📅 Ajout de l\'abonnement au panier...');
  console.log('🔢 Selling Plan ID:', sellingPlanId);
  console.log('🔗 Produit URL:', productUrl);
  
  // Feedback visuel
  link.style.opacity = '0.6';
  link.style.pointerEvents = 'none';
  link.style.cursor = 'wait';
  
  // Étape 1 : Récupérer les données du produit
  fetch(productUrl + '.json')
    .then(response => {
      if (!response.ok) {
        throw new Error('Erreur HTTP: ' + response.status);
      }
      return response.json();
    })
    .then(productData => {
      const product = productData.product;
      const defaultVariant = product.variants[0];
      
      console.log('📋 Produit:', product.title);
      console.log('🔢 Variant ID:', defaultVariant.id);
      
      // Étape 2 : Ajouter au panier avec abonnement
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: defaultVariant.id.toString(),
            quantity: 1,
            selling_plan: sellingPlanId
          }]
        })
      });
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(err.description || 'Erreur HTTP: ' + response.status);
        });
      }
      return response.json();
    })
    .then(cartData => {
      console.log('✅ Abonnement ajouté au panier:', cartData);
      
      // Déclencher l'événement de mise à jour du panier (pour les mini-paniers, etc.)
      if (typeof window.dispatchEvent !== 'undefined') {
        window.dispatchEvent(new CustomEvent('cart:updated'));
      }
      
      // Redirection vers le panier
      setTimeout(function() {
        window.location.href = '/cart';
      }, 300);
    })
    .catch(error => {
      console.error('❌ Erreur:', error);
      link.style.opacity = '1';
      link.style.pointerEvents = 'auto';
      link.style.cursor = 'pointer';
      alert('Une erreur est survenue lors de l\'ajout au panier: ' + (error.message || 'Erreur inconnue'));
    });
  
  return false;
}, true); // useCapture = true

console.log('✅ Script media-split-subscription.js actif');

